import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/core/services/auth.service';
import { AppAuthUser } from 'src/core/models/auth-user';

@Component({
    selector: 'app-start-page',
    templateUrl: './start-page.component.html',
    styleUrls: ['./start-page.component.scss'],
    standalone: false
})
export class StartPageComponent implements OnInit {
  currentUser: AppAuthUser | null = null;
  constructor(
    private _auth: AuthService,
  ) { }

  ngOnInit(): void {
    this
    ._auth
    .currentUserChanges()
    .subscribe((user) => {
      this.currentUser = user;
    });
  }

}
